import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { PROPERTY_BLOCK_WITHOUT_COMMUNITY } from "./apiRoutes";

const getPropertyBlocks = async () => await axiosAuth.get(`${PROPERTY_BLOCK_WITHOUT_COMMUNITY}`);

const useGetPropertyBlocks = (
  queryParams?: Omit<UseQueryOptions, "queryKey">
): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["property-blocks"],
    queryFn: () => getPropertyBlocks(),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPropertyBlocks;
